import React from 'react';

import paymentReducer from '../../../../components/transaction/Payment/form/reducer';
import { PaymentFormContext } from '../../../../components/transaction/Payment/form/useFormContext';
import useValidate from '../../../../components/transaction/Payment/form/validate';
import type { PaymentItemDetails, PaymentItemId, UniquePaymentId } from '../../../../generated-types';
import { OutboxWrapper } from '../../../../models/outbox';
import { EditOutboxModalContent } from './components';
import { getOutboxState } from './helpers';

interface EditOutboxModalProps {
    onClose: () => void;
    outboxItem: OutboxWrapper;
    outboxDetails: PaymentItemDetails;
    signSingleItem(itemId: PaymentItemId, outboxId: UniquePaymentId): void;
    modalOpenState: [boolean, (value: boolean) => void];
}

export default ({ onClose, outboxItem, signSingleItem, modalOpenState, outboxDetails }: EditOutboxModalProps) => {
    if (!outboxDetails.from.accountNumber) return <></>;

    const initialState = getOutboxState({ ...outboxDetails }, outboxDetails?.from.accountNumber);
    return (
        <PaymentFormContext validateHook={useValidate} reducer={paymentReducer} initialState={initialState}>
            <EditOutboxModalContent
                onClose={onClose}
                initialState={initialState}
                signSingleItem={signSingleItem}
                outboxDetails={outboxDetails}
                outboxId={outboxItem.uniqueId}
                modalOpenState={modalOpenState}
            />
        </PaymentFormContext>
    );
};
